import { render, staticRenderFns } from "./Rejected.vue?vue&type=template&id=65084ecc&scoped=true&"
import script from "./Rejected.vue?vue&type=script&lang=js&"
export * from "./Rejected.vue?vue&type=script&lang=js&"
import style0 from "./Rejected.vue?vue&type=style&index=0&id=65084ecc&prod&lang=scss&"
import style1 from "./Rejected.vue?vue&type=style&index=1&id=65084ecc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65084ecc",
  null
  
)

export default component.exports